import { useCallback, useContext } from 'react';
import { isEmpty } from 'ramda';
import { useOtherSettings } from '@namespace/cms';
import { useGetThemeConfig } from '@namespace/themes';
import { UserContext } from '@namespace/user';
import { getPayments } from '../../api/config';
import { paymentsActions } from '../../store';
import { normalizePaymentServices } from '../../utils/normalizePaymentServices';
import { usePSDescriptions } from '../usePSDescriptions';

const { GET_SW_CONFIG } = paymentsActions;

export const useGetPaymentConfigSWRequest = () => {
  const { getPaymentsConfig } = useGetThemeConfig('PaymentConfigSW');
  const [{ activeWallet = {}, id }] = useContext(UserContext);
  const { currency } = activeWallet;

  const paymentServicesDescription = usePSDescriptions();
  const { crypto: cryptoConfig = {} } = useOtherSettings();

  const updateSWConfig = useCallback(async () => {
    if (!isEmpty(paymentServicesDescription)) {
      const getConfig = getPaymentsConfig || getPayments;
      const paymentSystems = await getConfig(id);
      const body = normalizePaymentServices(
        paymentSystems || {},
        paymentServicesDescription,
        currency,
        cryptoConfig
      );
      GET_SW_CONFIG(body);
    }
  }, [
    cryptoConfig,
    currency,
    getPaymentsConfig,
    id,
    paymentServicesDescription
  ]);

  return updateSWConfig;
};
